import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Globals, Constants, Permissions } from 'utils';
import Header from './header';
import $ from 'jquery';
import { Logo, WhatsappImage } from 'assets/img';
import { on } from 'jetemit';
import { Menu as MenuIcons, ArrowUp, ArrowBottom, WhatsappWhiteIcon, InstagramWhiteIcon } from 'assets/icons';
import { Modal } from 'components';
import ModalExchange from './admin/modal-exchange';
import ModalPassword from './password';
import ModalProfile from './profile';
import ModalPriceMeter from './admin/modal-price-meter';
import ModalReferral from 'screens/client/home/modal-referral';

interface MenuItem {
	name: string;
	path: string;
	submenu?: MenuItem[];
	icon?: string;
	permission?: string;
	onClick?: () => void;
	iconActive?: string;
	code: string;
	isLogout?: boolean;
	className?: string;
}

class Menu extends React.Component<any> {

	state: any = {
		leftOpen: this.props.withLayout ? false : true,
		openResponsive: false,
		items: [
			{ name: 'Moderadores', path: '/admin/moderators', icon: MenuIcons.MenuModerators, iconActive: MenuIcons.MenuModerators, permission: Constants.MODULES.MODERATORS },
			{ name: 'Servicios', path: '/admin/services', icon: MenuIcons.MenuServices, iconActive: MenuIcons.MenuServices, permission: Constants.MODULES.SERVICES },
			{ name: 'Operarios', path: '/admin/operators', icon: MenuIcons.MenuOperators, iconActive: MenuIcons.MenuOperators, permission: Constants.MODULES.OPERATORS },
			{ name: 'Descuentos', path: '/admin/discounts', icon: MenuIcons.MenuDiscount, iconActive: MenuIcons.MenuDiscount, permission: Constants.MODULES.DISCOUNTS },
			{ name: 'Planificación', path: '/admin/planning', icon: MenuIcons.MenuPlanning, iconActive: MenuIcons.MenuPlanning, permission: Constants.MODULES.PLANNING },
			{ name: 'Tasa de cambio', icon: MenuIcons.MenuExchange, iconActive: MenuIcons.MenuExchange, permission: Constants.MODULES.EXCHANGE, onClick: () => {
				this.setState({
					visible_exchange: true
				});	
			} },
			{ name: 'Citas', path: '/admin/quotes', icon: MenuIcons.MenuQuotes, iconActive: MenuIcons.MenuQuotes, permission: Constants.MODULES.QUOTES },
			{ name: 'Tipos de cita', path: '/admin/quote-types', icon: MenuIcons.MenuQuoteTypes, iconActive: MenuIcons.MenuQuoteTypes, permission: Constants.MODULES.QUOTE_TYPES },
			{ name: 'Reportes', path: '/admin/reports', icon: MenuIcons.MenuReports, iconActive: MenuIcons.MenuReports, permission: Constants.MODULES.REPORTS, submenu: [
				{ name: 'Reporte de Servicios', path: '/admin/reports/services' },
				{ name: 'Servicios Recurrentes', path: '/admin/reports/recurring-services' },
				{ name: 'Planificación', path: '/admin/reports/planning' },
				{ name: 'Encuestas de Satisfacción', path: '/admin/reports/surveys' },
			] },
			{ name: 'Pagos Corporativos', path: '/admin/corporate-payments', icon: MenuIcons.MenuPayment, iconActive: MenuIcons.MenuPayment, permission: Constants.MODULES.CORPORATE_PAYMENTS },
			{ name: 'Referidos', path: '/admin/points', icon: MenuIcons.MenuClientPoints, iconActive: MenuIcons.MenuClientPoints, permission: Constants.MODULES.POINTS },
			{ name: 'Clientes', path: '/admin/clients', icon: MenuIcons.MenuClients, iconActive: MenuIcons.MenuClients, permission: Constants.MODULES.CLIENTS },
			{ name: 'Cuentas Bancarias', path: '/admin/bank-accounts', icon: MenuIcons.MenuBankAccounts, iconActive: MenuIcons.MenuBankAccounts, permission: Constants.MODULES.BANK_ACCOUNTS },
			{ name: 'Complementos', path: '/admin/accessories', icon: MenuIcons.MenuAccessories, iconActive: MenuIcons.MenuAccessories, permission: Constants.MODULES.ACCESSORIES },
			{ name: 'Postulaciones', path: '/admin/job-applications', icon: MenuIcons.MenuJobApplications, iconActive: MenuIcons.MenuJobApplications, permission: Constants.MODULES.JOB_APPLICATIONS },
			{ name: 'Tienda', path: '/admin/shop', icon: MenuIcons.MenuShop, iconActive: MenuIcons.MenuShop, permission: [
				Constants.MODULES.ORDERS,
				Constants.MODULES.INVENTORY,
			    Constants.MODULES.PRODUCTS,
			    Constants.MODULES.COMBOS,
			    Constants.MODULES.BANNERS,
			    Constants.MODULES.CATEGORIES
			],onClick: () => {
				this.setState({
					visible_shop_menu: !this.state.visible_shop_menu
				});	
			} },
			// { name: 'Precio por m2', icon: MenuIcons.MenuPriceMeter, iconActive: MenuIcons.MenuPriceMeter, permission: Constants.MODULES.PRICE_METER, onClick: () => {
			// 	this.setState({
			// 		visible_price_meter: true
			// 	});	
			// } },
			{ name: 'Lugares Excluidos', path: '/admin/excluded-places', icon: MenuIcons.MenuPlaces, iconActive: MenuIcons.MenuPlaces, permission: Constants.MODULES.EXCLUDED_PLACES },
			// { name: 'Jornadas', path: '/admin/journeys', icon: MenuIcons.MenuJourneys, iconActive: MenuIcons.MenuJourneys, permission: Constants.MODULES.JOURNEYS },
		],
		items_shop: [
			{ name: 'Pedidos y ventas', path: '/admin/shop/orders', permission: Constants.MODULES.ORDERS },
			{ name: 'Inventario', path: '/admin/shop/inventory', permission: Constants.MODULES.INVENTORY },
			{ name: 'Productos', path: '/admin/shop/products', permission: Constants.MODULES.PRODUCTS },
			{ name: 'Combos', path: '/admin/shop/combos', permission: Constants.MODULES.COMBOS },
			{ name: 'Banners', path: '/admin/shop/banners', permission: Constants.MODULES.BANNERS },
			{ name: 'Categorías', path: '/admin/shop/categories', permission: Constants.MODULES.CATEGORIES }			
		],
		items_client: [
			{ name: 'Inicio', path: '/client/quotes/request', icon: MenuIcons.MenuClientHome, iconActive: MenuIcons.MenuClientHome },
			{ name: 'Perfil', path: '/client/profile', icon: MenuIcons.MenuClients, iconActive: MenuIcons.MenuClients },
			{ name: 'Usuarios', path: '/client/users', icon: MenuIcons.MenuClientProfile, iconActive: MenuIcons.MenuClientProfile, corporate: true },
			{ name: 'Historial de Cita', path: '/client/quotes', icon: MenuIcons.MenuClientQuotes, iconActive: MenuIcons.MenuClientQuotes },
			{ name: 'Mis Conectados', path: '/client/points', icon: MenuIcons.MenuMyConnects, iconActive: MenuIcons.MenuMyConnects },
			{ name: 'Conecta', icon: MenuIcons.MenuConnect, iconActive: MenuIcons.MenuConnect, className: 'menu-connect', onClick: () => {
				this.setState({
					visible_connect: true
				});
			} },
			{ name: 'Descuentos', path: '/client/discounts', icon: MenuIcons.MenuDiscount, iconActive: MenuIcons.MenuDiscount },
		],
		visible_exchange: false,
		visible_password: false,
		visible_profile: false,
		visible_shop_menu: false,
		visible_price_meter: false,
		unsubscribe: () => {},
		unsubscribeResponsive: () => {},
		visible_connect: false
	}

	componentDidMount() {
		this.setState({
			unsubscribe: on('open-menu',() => {
				this.setState({
					leftOpen: !this.state.leftOpen
				});
			}),
			unsubscribeResponsive: on('open-menu-responsive',() => {
				this.setState({
					openResponsive: !this.state.openResponsive
				})
			})
		});
	}

	componentWillUnmount() {
		this.state.unsubscribe();
		this.state.unsubscribeResponsive();
	}

	toggleSidebar = () => {
	    let key: any = `leftOpen`;
	    // @ts-ignore
	    this.setState({ [key]: !this.state[key] });
	}

	checkActive = (value: string, current: string) => {
		return current.includes(value);
	}

	changeMenu = (item: MenuItem) => {
		if (item.submenu && !this.state.leftOpen) {
			this.toggleSidebar();
		}
	}

	checkPermission = (item: any) => {
		if (this.props.user?.level_id == Constants.LEVELS.ADMIN) {
			return true;
		}
		const permissions = this.props.user?.module_permissions?.filter((i: any) => i.read).map((i: any) => i.module_id) || [];
		if (Array.isArray(item.permission)) {
			let _continue = false;
			item.permission.forEach((i: any) => {
				if (permissions.indexOf(i) != -1) {
					_continue = true;
				}
			});
			return _continue;
		}
		else {
			return permissions.indexOf(item.permission) != -1;
		}		
	}

	closeNavbar = () => {
		// @ts-ignore
		$('#collapsibleNavbar').collapse('hide');
	}

	toggleResponsive = () => {
		this.setState({
	  		openResponsive: !this.state.openResponsive
	  	});
	}

	closeResponsive = () => {
		this.setState({
	  		openResponsive: !this.state.openResponsive,
	  		visible_shop_menu: false
	  	});
	}

	onClose = () => {
		this.setState({
			visible_exchange: false
		});
	}

	onClosePriceMeter = () => {
		this.setState({
			visible_price_meter: false
		});
	}

	onCloseProfile = () => {
		this.setState({
			visible_profile: false
		});
	}

	onClosePassword = () => {
		this.setState({
			visible_password: false
		});
	}

	onCloseConnect = () => {
		this.setState({
			visible_connect: false
		});
	}

	render() {
		const { visible_exchange, visible_password, visible_profile, visible_price_meter, visible_connect } = this.state;
		let leftOpen = this.state.leftOpen ? "open" : "closed";
		let items = [];

		if (this.props.user) {
			const isClient = (this.props.user?.level_id != Constants.LEVELS.ADMIN && this.props.user?.level_id != Constants.LEVELS.MODERATOR);

			if (isClient) {
				items = this.state.items_client.filter((i: any) => !i.corporate || this.props.user?.user_type_id == Constants.USER_TYPES.CORPORATE);
			}
			else {
				items = this.state.items;
			}
		}

		return (
			<React.Fragment>
				<Modal
		          className="modal-send-referral"
		          visible={ visible_connect }
		          title=""
		          centered
		          onClose={ () => this.onCloseConnect() }
		        >
		          {/*
		          // @ts-ignore */}
		          <ModalReferral
		          	onClose={ () => this.onCloseConnect() }
		          />
		      	</Modal>

				<Modal
		          className="modal-exchange"
		          visible={ visible_exchange }
		          title="Tasa de Cambio"
		          centered
		          onClose={ () => this.onClose() }
		        >
		          {/*
		          // @ts-ignore */}
		          <ModalExchange
		          	onClose={ () => this.onClose() }
		          />
		      	</Modal>

		      	<Modal
		          className="modal-exchange"
		          visible={ visible_price_meter }
		          title="Actualizar precio"
		          centered
		          onClose={ () => this.onClosePriceMeter() }
		        >
		          {/*
		          // @ts-ignore */}
		          <ModalPriceMeter
		          	onClose={ () => this.onClosePriceMeter() }
		          />
		      	</Modal>

		      	<Modal
		          className="modal-password"
		          visible={ visible_password }
		          title=""
		          onClose={ () => this.onClosePassword() }
		        >
		          {/*
		          // @ts-ignore */}
		          <ModalPassword
		          	onClose={ () => this.onClosePassword() }
		          />
		      	</Modal>

		      	<Modal
		          className="modal-profile"
		          visible={ visible_profile }
		          title=""
		          onClose={ () => this.onCloseProfile() }
		        >
		          {/*
		          // @ts-ignore */}
		          <ModalProfile
		          	onClose={ () => this.onCloseProfile() }
		          />
		      	</Modal>

				<div id="left" className={ leftOpen }>
					<div className={`sidebar ${ leftOpen + ' ' + (this.state.openResponsive ? 'open-responsive' : '') }`}>
						{/*<div className={ `shadow-close ${ this.state.openResponsive ? 'open' : '' }` } onClick={ this.closeResponsive }></div>*/}
						{
							this.props.user != null && (
								<>
									<div className="container-menu">
										<div className={ `menu-shop ${ this.state.visible_shop_menu ? 'open' : '' }`}>
											<ul>
												{
													this.state.items_shop.map((_item: any, index: number) => {
														if (!_item.permission || this.checkPermission(_item)) {
															return (
																<li>
																	<Link onClick={ () => {
																		this.closeResponsive();
																	} } to={ _item.path }>{ _item.name }</Link>
																</li>
															)
														}
													})
												}
											</ul>
										</div>
										<div className="menu">
											<div className="container-scroll">
												<ul className={ leftOpen }>
													{ items.map((i: MenuItem,index: number) => {
														return (
															<React.Fragment key={ index }>
																{
																	(!i.permission || this.checkPermission(i)) && (
																		<li className={ `nav-item ${ this.checkActive(i.path,this.props.history.location.pathname) ? 'active' : '' } ${ i.className || '' }` }>
																			<Link to={ i.path } className={ `${ i.submenu && i.submenu.length > 0 ? 'contain-submenu' : '' }` } onClick={ (e: any) => {
																				if (i.onClick) {
																					e.preventDefault();
																					i.onClick();
																				}
																				else {
																					if (i.submenu && i.submenu.length > 0 && this.checkActive(i.path,this.props.history.location.pathname) && this.props.open_menu) {
																						this.props.dispatch({
																							type: 'SET_OPEN_MENU',
																							payload: false
																						});
																						e.preventDefault();
																					}
																					else {
																						this.props.dispatch({
																							type: 'SET_OPEN_MENU',
																							payload: true
																						});
																						this.changeMenu(i);
																						this.closeResponsive();
																					}
																				}																	
																			} }>
																				<div className={ `container-icon-menu ${ this.checkActive(i.path,this.props.history.location.pathname) ? 'active' : '' }` }>
																					{
																						i.icon && (
																							<img src={ this.checkActive(i.path,this.props.history.location.pathname) ? i.iconActive : i.icon } />
																						)
																					}
																				</div>												
																				<span className={ leftOpen }>
																					{ i.name }
																					{
																						i.submenu && i.submenu.length > 0 && (
																							<React.Fragment>
																								{
																									this.checkActive(i.path,this.props.history.location.pathname) ? (
																										<img className="arrow-drop" src={ this.props.open_menu ? ArrowUp : ArrowBottom } />
																									) : (
																										<img className="arrow-drop" src={ ArrowBottom } />
																									)
																								}
																							</React.Fragment>
																						)
																					}
																				</span>
																			</Link>
																			{
																				this.props.open_menu && (
																					<div className={ `${ i.submenu && i.submenu.length > 0 && this.checkActive(i.path,this.props.history.location.pathname) ? 'container-submenu' : '' }` }>
																						{
																							leftOpen != 'closed' && this.checkActive(i.path,this.props.history.location.pathname) && i.submenu && i.submenu.map((item: MenuItem,index: number) => {
																								if (!item.permission || this.checkPermission(item)) {
																									return (
																										<li className={ 'nav-item item-submenu ' + (this.props.history.location.pathname == item.path ? 'active' : '') }>
																											<Link to={ item.path } className="submenu">
																												{
																													item.icon && (
																														<img src={ item.icon } />
																													)
																												}
																												{ item.name }
																											</Link>
																										</li>
																									)
																								}
																							})
																						}
																					</div>
																				)
																			}
																		</li>
																	)
																}												
															</React.Fragment>
														)
													}) }
												</ul>
												{
													this.props.user?.level_id == Constants.LEVELS.CLIENT && (
														<div className="container-socials row">
															{/*<div className="col-md-6 text-center">
																<a href={ `https://wa.me/` + this.props.contact_info?.whatsapp } target="_blank">
																	<img src={ WhatsappWhiteIcon } />
																</a>
															</div>*/}
															<div className="col-md-12 text-center">
																<a href={ this.props.contact_info?.instagram } target="_blank" onClick={ (e: any) => Globals.openWhatsapp(e,this.props.contact_info?.instagram) }>
																	<img src={ InstagramWhiteIcon } />
																</a>
															</div>
														</div>
													)
												}
											</div>
										</div>
									</div>
								</>
							)
						}
						<div className={ `container-router ${ leftOpen }` } onClick={ () => this.setState({
							visible_shop_menu: false
						}) }>
							<Header 
								withLayout={ this.props.withLayout }
								useSocials={ this.props.useSocials }
								openProfile={ () => {
									this.setState({
										visible_profile: true
									});
								} }
								openPassword={ () => {
									this.setState({
										visible_password: true
									});
								} }
								className={ leftOpen + ' ' + (items.length > 0 && 'header-responsive') } />
							<div className={ `container-padding-router ${ items.length > 0 && 'container-responsive' }` }>{ this.props.children }</div>
							{
								(!this.props.user || this.props.user?.level_id == Constants.LEVELS.CLIENT) && (
									<a href={ `https://wa.me/` + this.props.contact_info?.whatsapp } target="_blank" onClick={ (e: any) => Globals.openWhatsapp(e,`https://wa.me/` + this.props.contact_info?.whatsapp) }>
										<button className="btn-whatsapp-footer">
											<div className="container-whatsapp-footer">
												<img src={ WhatsappImage } />
												<p>¿Cómo puedo ayudarte?</p>
											</div>
										</button>
									</a>
								)
							}
						</div>
					</div>
				</div>
			</React.Fragment>
		)
	}
}

export default connect((state: any) => {
	return {
		user: state.user,
		open_menu: state.open_menu,
		contact_info: state.contact_info
	}
})(Menu);